import { render, staticRenderFns } from "./purchased-customer.vue?vue&type=template&id=50e18fd0&scoped=true"
import script from "./purchased-customer.vue?vue&type=script&lang=js"
export * from "./purchased-customer.vue?vue&type=script&lang=js"
import style0 from "./purchased-customer.vue?vue&type=style&index=0&id=50e18fd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e18fd0",
  null
  
)

export default component.exports